<template>
  <div>
    <v-tooltip
      v-model="isError"
      right
      allow-overflow
      nudge-bottom="25"
      nudge-left="25"
      content-class="cart-part-tooltip"
    >
      <template v-slot:activator="{ props }">
        <v-text-field
          v-bind="props"
          :value="item.quantity"
          type="number"
          min="1"
          class="count__input"
          :rules="[rules.validateItemQuantity(item.multiplicity,item.minVolume)]"
          @input.native="changePositionQuantity($event, item.code)"
        >
          <div
            slot="activator"
            class="count__controls"
          >
            <svg
              width="10"
              height="9"
              viewBox="0 0 16 9"
              @click="incrementPositionQuantity(item.code)"
            >
              <path d="M8,0l8,9H0Z" />
            </svg>
            <svg
              width="10"
              height="9"
              viewBox="0 0 16 9"
              @click="decrementPositionQuantity(item.code)"
            >
              <path
                d="M8,0l8,9H0Z"
                transform="translate(16 9) rotate(180)"
              />
            </svg>
          </div>
        </v-text-field>
      </template>
      <span>{{ errorMessage }}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: 'CartPartQuantity',

  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isError: false,
      errorMessage: '',
      rules: {
        validateItemQuantity: (multiplicity, minVolume) => ((value) => {
          this.isError = false;
          const errors = [];

          if (multiplicity > 1 && (value % multiplicity)) {
            this.isError = true;
            errors.push(this.$t('validation.multiplicity', { multiplicity }));
          }

          if (minVolume > 1 && (value < minVolume)) {
            this.isError = true;
            errors.push(this.$t('validation.min_volume', { minVolume }));
          }

          if (this.isError) {
            this.errorMessage = errors.join(', ');
          }

          return !this.isError;
        }),
      },
    };
  },

  methods: {
    incrementPositionQuantity(code) {
      this.$store.commit('incrementPositionQuantity', { code });
    },

    decrementPositionQuantity(code) {
      this.$store.commit('decrementPositionQuantity', { code });
    },

    changePositionQuantity(event, code) {
      const quantity = Number(event.target.value);
      if (!Number.isInteger(quantity) || quantity <= 0) {
        /* eslint-disable no-underscore-dangle */
        const prevQuantity = Number(event.target._value);
        /* eslint-enable no-underscore-dangle */
        this.$store.commit('changePositionQuantity', { code, quantity: prevQuantity });
        event.target.value = prevQuantity;
      } else {
        this.$store.commit('changePositionQuantity', { code, quantity });
      }
    },

  },
};
</script>

<style lang="scss">
    .cart-part-tooltip {
        background-color: #EF9A9A !important;
    }
</style>
